export default {
    user:{
        account:"账号",
        name:"显示名称",
        btn_reset_pwd:"重置密码",
        btn_sync_contact:"同步联系人",
        btn_sync_user:"同步用户",
        status:"状态",
        type:"角色类型",
        add_user:"新增账号",
        add_role:"新增角色",
        account_info:"账号信息",
        role_info:"角色信息",
        role_name:"角色名称",
        belonging:"客户",
        proxy_customer:"代理客户",
        edit_account:"编辑账号",
        gender:"性别",
        user:"用户",
        role:"角色",
        resource:"可交互资源",
        governing_customers:"管辖企业",
        associated_architecture:"可访问组织",
        tip_before_delete:"是否确认删除用户？",
        //账号类型
        type_customer_normal:"企业使用",
        type_customer_admin:"企业管理",
        type_platform_normal:"平台使用",
        type_platform_admin:"平台管理",
        type_customer_proxy:"代理管理",
        synchronizing:"正在同步中,请勿关闭页面...",
        code_200:"重置成功",
        code_0:"同步失败",
        code_1:"同步成功",
        code_2:"存在相同的记录，已跳过重复的记录",
        code_404:"找不到用户信息",
        code_other:"未知错误",
        gender_1:"男",
        gender_0:"女",
        remarks:"备注",
        view_associated_user:"查看关联用户图标",
        role_edit:"编辑角色",
        role_info:"角色信息",

        tip_del_default_role:"默认角色禁止删除",
        tip_del_default_role_multi:"所选择数据存在默认角色,默认角色禁止删除",
        tip_del_role:"删除角色将删除关联的用户。是否要继续？",
        tip_least_reain_one_data:"至少保留一条数据",


        //编辑用户返回的状态码
        user_edit_code_200:"编辑成功",
        user_new_code_200:"新增成功",
        user_new_code_201:"新增成功,但同步联系人失败",
        user_edit_code_201:"编辑成功,但同步联系人失败",
        user_edit_code_412:"电子邮箱格式错误",
        user_new_code_414:"状态不能为空",
        user_edit_code_416:"账号已存在",
        user_edit_code_417:"用户名称已存在",
        user_edit_code_418:"手机号码已存在",
        user_edit_code_419:"电子邮箱已存在",
        user_edit_code_501:"编辑用户成功，但由于账号为注销状态不允许失败",
        user_new_code_501:"新增用户成功，但由于账号为注销状态不允许失败",
        //编辑角色返回的状态码
        role_edit_code_405:"角色名不能为空",
        role_edit_code_406:"角色名不能超过50个字符",
        role_edit_code_407:"客户不能为空",
        role_edit_code_408:"客户必须要与当前用户的组织架构客户一致",
        role_edit_code_409:"存在相同的角色名",
        role_edit_code_410:"角色类型不能为空",
        role_edit_code_411:"角色状态不能为空",
        role_edit_code_412:"备注不能超过250个字符",
        role_edit_code_413:"操作资源不能为空",
        role_edit_code_415:"代理客户至少选择一个",
        role_edit_code_500:"保存失败，请重试",


        popover_icon:"图标代表的含义如下",
        popover_role_type:"角色类型图标",
        popover_account_type:"账号类型图标",
        popover_status:"状态图标",
        popover_account_default:"账号默认图标",
    }
}